// validators/regex-validator.js
import { z } from "zod";
import { ValidatorInterface } from "../validator-interface";

export class RegexValidator extends ValidatorInterface {
    getZodSchema(baseSchema, options = {}) {
        const regexString = options.value; // Expecting the regex pattern as a string
        const labelText = options.labelText || "This field";
        const message = options.message || `${labelText} has an invalid format`;

        if (!regexString || typeof regexString !== "string") {
            // eslint-disable-next-line no-console
            console.warn("Invalid or missing regex pattern provided for RegexValidator:", regexString);
            return baseSchema; // Return base schema if regex is invalid
        }

        let regex;
        try {
            // Attempt to create a RegExp object from the string pattern
            // Assume no flags are passed, or modify to parse flags if needed
            regex = new RegExp(regexString);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Error creating RegExp from pattern:", regexString, error);
            return baseSchema; // Return base schema on invalid regex pattern
        }

        // Apply only to string schemas
        if (baseSchema instanceof z.ZodString) {
            return baseSchema.regex(regex, { message });
        } else {
            // eslint-disable-next-line no-console
            console.warn("RegexValidator applied to non-string schema. Requires ZodString.");
            // Optional: could try refining non-string types after converting to string?
            return baseSchema; // Return base schema if type is not supported
        }
    }

    getErrorMessage(field, options = {}) {
        const labelText = options.labelText || "This field";
        return options.message || `${labelText} has an invalid format`;
    }
}
